export default "__VITE_ASSET__abaa8a26__"